import { render, staticRenderFns } from "./EmptyResult.vue?vue&type=template&id=2486c9dc"
import script from "./EmptyResult.vue?vue&type=script&lang=ts"
export * from "./EmptyResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports